import { useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { RaRecord } from 'react-admin';
import { DeleteWithConfirmButton, useRecordContext, useResourceContext } from 'react-admin';

type RecordRowActionsProps = {
  editState?: unknown;
  showDelete?: boolean;
};

export const RecordRowActions = ({ editState, showDelete = false }: RecordRowActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const record = useRecordContext<RaRecord>();
  const resource = useResourceContext();
  if (!record?.id || !resource) return null;

  const stopRowClick = (event: React.MouseEvent) => event.stopPropagation();

  return (
    <>
      <Tooltip title="Record actions">
        <IconButton
          size="small"
          aria-label="Record actions"
          onClick={(event) => {
            stopRowClick(event);
            setAnchorEl(event.currentTarget);
          }}
        >
          <MoreHorizIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={stopRowClick}
      >
        <MenuItem component={RouterLink} to={`/${resource}/${record.id}/show`}>
          <ListItemIcon>
            <VisibilityOutlinedIcon fontSize="small" />
          </ListItemIcon>
          View
        </MenuItem>
        <MenuItem component={RouterLink} to={`/${resource}/${record.id}`} state={editState}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>
        {showDelete ? <Divider sx={{ my: 0.5 }} /> : null}
        {showDelete ? (
          <DeleteWithConfirmButton
            record={record}
            resource={resource}
            redirect={false}
            label="Delete"
            sx={{
              width: '100%',
              justifyContent: 'flex-start',
              px: 2,
              py: 0.75,
              borderRadius: 0,
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '1rem'
            }}
          />
        ) : null}
      </Menu>
    </>
  );
};
